export default function initialize() {
  $("[data-tc-behavior]").each(function (index) {
    const behaviorName = $(this).attr("data-tc-behavior");
    if (window.hasOwnProperty(behaviorName)) {
      window[behaviorName].call(null, this);
    }
    console.log("behavior" + index + ": " + $(this).attr("data-tc-behavior"));
  });

};

window.initializeTicketcoBehaviors = initialize;
